
const UnderstandingGoalsSection = () => {
  const goals = [
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Financial Security',
      description: 'Maximizing the value of your life\'s work while ensuring a comfortable retirement and legacy for your family.'
    },
    {
      icon: 'ri-heart-line',
      title: 'Emotional Peace of Mind',
      description: 'Knowing your business will continue to thrive and your employees will be taken care of under new ownership.'
    },
    {
      icon: 'ri-user-line',
      title: 'Personal Freedom',
      description: 'Having the flexibility to pursue new interests, spend time with family, or start your next chapter on your terms.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Legacy Protection',
      description: 'Ensuring your business values, customer relationships, and community impact remain intact for years to come.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-playfair text-4xl font-bold text-navy mb-4">
            Understanding Your Goals
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Every business owner has different priorities when it comes to selling. We take time to understand what matters most to you.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {goals.map((goal, index) => (
            <div key={index} className="bg-soft-gray rounded-lg p-8 hover:shadow-lg transition-shadow duration-300">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#C9A227] rounded-lg flex-shrink-0">
                  <i className={`${goal.icon} text-white text-xl`}></i>
                </div>
                <div>
                  <h3 className="font-semibold text-navy mb-3 text-lg">{goal.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{goal.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-navy rounded-lg p-8 text-center">
          <h3 className="font-playfair text-2xl font-semibold text-white mb-4">
            Your Goals Drive Our Approach
          </h3>
          <p className="text-gray-200 leading-relaxed max-w-3xl mx-auto">
            We don't believe in one-size-fits-all solutions. Every conversation starts with understanding your unique situation, timeline, and priorities. Only then do we craft an approach that works for you.
          </p>
        </div>
      </div>
    </section>
  );
};

export default UnderstandingGoalsSection;
